import type { RouteObject } from 'react-router-dom';

import PagePremission from '@/routes/Restrictions/PagePremission';
import { lazyRouteComponent } from '@/utils/lazyLoad';
import InventoryPermission from '@/utils/premissions/InventoryPermission.enum';

// Lazy load the Inventory page
const InventoryPage = lazyRouteComponent(
  () => import('@/pages/Warehouses/Inventory'),
);

// Lazy load the Create Inventory page
const CreateInventoryPage = lazyRouteComponent(
  () => import('@/pages/Warehouses/Inventory/CreateInventory'),
);

// Lazy load the View Inventory page
const ViewInventoryPage = lazyRouteComponent(
  () => import('@/pages/Warehouses/Inventory/ViewInventory'),
);

// Define routes for Warehouses
const WarehousesRoutes: RouteObject[] = [
  {
    path: 'inventory',
    element: (
      <PagePremission prem={InventoryPermission.Prem_Inventory_View}>
        <InventoryPage />
      </PagePremission>
    ),
  },
  {
    path: 'inventory/create',
    element: (
      <PagePremission prem={InventoryPermission.Prem_Inventory_Create}>
        <CreateInventoryPage />
      </PagePremission>
    ),
  },
  {
    path: 'inventory/:id',
    element: (
      <PagePremission prem={InventoryPermission.Prem_Inventory_View}>
        <ViewInventoryPage />
      </PagePremission>
    ),
  },
];

// Preloading API for performance optimization
export const prefetchWarehousesRoutes = {
  prefetchInventory: () => void import('@/pages/Warehouses/Inventory'),
};

export default WarehousesRoutes;
